// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"8c8f9be75dadac20e5cf","532":"846cd40b6497e44e5e1a","678":"1369c39ff6d4c750f340","883":"48178696ae132d22e10a"}[chunkId] + ".js";
};